import { StatementType } from './statement-types';

export const JapaneseStatements: Record<StatementType, string[]> = {
  annoyed: [
    '昨日言わなかったっけ？',
    'ちゃんと見てないと思わないで！',
    'うるさくて考えられない！',
    'それって受動攻撃的じゃない？',
    'そこに置くものじゃないでしょ！',
    '君が芝刈り機を借りてから7時間と15日が経った！',
    'そんなに音立てて噛まないでくれる？',
    'もう取ってよ！',
    '良いことが言えないなら何も言わないで！',
    'もう行こうよ。',
  ],
  frustrated: [
    'はいはい、君のやり方でいいよ！',
    '一生できる気がしない！',
    'サイトが読み込まない！',
    'この缶開かない！',
    'そんな開け方じゃ無理！',
    '最後の一言を言わないと気が済まないんだね！',
  ],
  angry: [
    '一体何してるつもりだ！？',
    '陰気な毒ヘビのろくでなし！',
    'ぶっ殺してやる！',
    'いや、お前が間違ってる！',
    '守ってくれるはずだったのに！',
  ],
  random: [
    'ガチョウが来る！ガチョウが来る！',
    'サツマイモは甘くもないしジャガイモでもない。',
    'まあいいさ！ヤッラ！',
    '奇跡は終わらないのか？',
    '「わあ、ブルーベリー多すぎ！」',
    'なんてこった！',
    '本当にそれやるの？',
    '主よ、憐れみを！',
    '今日は空がすごく青い。',
    'オバケなんて怖くない！',
    '料理できないんじゃない？',
    '落ち着いて深呼吸しよう。',
    '愛こそ答え。',
  ],
  child: [
    'はは！',
    '遅いよ！',
    'おおっ！',
    '年寄り！',
    'はははは',
    'うぇーい',
    'もう諦める？',
    'これ見て！',
    '疲れてきた？',
    'ちょっと失礼！',
    '気をつけて！',
  ],
  'child-no': ['ダメ！'],
  'stay-near-me': ['そばにいて、離れないで。'],
};
